/**
 * Focus mode: while a screen needs the whole display (the guided brew on an iPad on the counter), the app shell
 * hides its navigation chrome. Screens opt in with `useFocusMode(active)`; Layout reads `useFocusModeActive()`.
 * Counted, so overlapping/StrictMode double mounts can't leave it stuck on.
 */
import { useEffect } from 'react';
import { create } from 'zustand';

const useFocusStore = create<{ count: number; inc: () => void; dec: () => void }>()((set) => ({
  count: 0,
  inc: () => set((s) => ({ count: s.count + 1 })),
  dec: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));

/** Hide app navigation while `active` is true and the calling component is mounted. */
export function useFocusMode(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    useFocusStore.getState().inc();
    return () => useFocusStore.getState().dec();
  }, [active]);
}

export function useFocusModeActive(): boolean {
  return useFocusStore((s) => s.count > 0);
}
